function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#194616",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M17.846 6.597a7.872 7.872 0 0 0-3.754-2.314A7.891 7.891 0 0 0 11.2 4.05a7.727 7.727 0 0 0-4.406 1.908 8.039 8.039 0 0 0-2.252 3.36 7.898 7.898 0 0 0-.124 4.714 7.836 7.836 0 0 0 2.105 3.52 7.791 7.791 0 0 0 3.619 1.994 7.856 7.856 0 0 0 5.649-.739 7.873 7.873 0 0 0 3.212-3.286 7.924 7.924 0 0 0 .714-5.255 7.969 7.969 0 0 0-1.87-3.668zM12.16 17.575c-.775.296-1.674.357-2.437-.024-.578-.283-.972-.85-1.12-1.453-.221-.873-.074-1.796.222-2.633.135-.382.307-.739.492-1.096-.665.665-1.317 1.342-1.97 2.019.973-1.33 2.02-2.622 3.176-3.803.615-.591 1.23-1.17 1.87-1.723a5.85 5.85 0 0 1 .69-.542c-.443.566-.812 1.17-1.145 1.797-.418.788-.8 1.612-1.046 2.474-.246.874-.394 1.834-.061 2.707.197.468.541.948 1.07 1.071.948.234 1.982-.012 2.745-.603-.677.763-1.514 1.428-2.486 1.81zm2.61-9.243c-.198-.098-.382-.184-.58-.283-.184.111-.38.21-.565.308.037-.21.061-.419.098-.64l-.48-.443c.21-.037.419-.074.64-.11.086-.198.185-.395.27-.592.1.185.198.382.296.579.21.024.431.061.653.086-.16.148-.296.308-.456.468.05.197.086.406.123.627z"
}));

var SvgIcIsbt = function SvgIcIsbt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcIsbt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_isbt.6cd890e1.svg";
export { ForwardRef as ReactComponent };